import React, { useRef, useState, useEffect } from "react";
import "./Reception.css";

const RECEPTION_URL = "https://reception.rileygramlich.dev";

const capabilities = [
    {
        title: "Answers every enquiry",
        detail:
            "Picks up calls and messages at any hour, including evenings, weekends, and the moments your team is already on another line.",
    },
    {
        title: "Knows your business",
        detail:
            "Trained on your services, hours, pricing, and policies so callers get accurate answers instead of a generic script.",
    },
    {
        title: "Books and qualifies",
        detail:
            "Collects the details that matter, screens out the noise, and drops confirmed appointments straight into your calendar.",
    },
    {
        title: "Hands off cleanly",
        detail:
            "Sends a written summary and transcript to your inbox after every conversation, and escalates urgent calls to a real person.",
    },
];

export default function Reception() {
    const targetRef = useRef();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            const entry = entries[0];
            if (entry.isIntersecting && !isVisible) {
                setIsVisible(true);
            }
        });
        observer.observe(targetRef.current);
    }, [isVisible]);

    const className = "Reception hidden " + (isVisible ? "show" : "");

    return (
        <section ref={targetRef} className={className} id="reception">
            <p className="reception-eyebrow">Our own product</p>
            <h1 className="title">AI Virtual Receptionist</h1>
            <p className="section-subtitle">
                A missed call is usually a missed customer. Our virtual
                receptionist answers for your business around the clock, handles
                the routine questions, and passes the real opportunities to you.
            </p>

            <div className="reception-layout">
                <article className="reception-card reception-primary">
                    <h3>See it for yourself</h3>
                    <p>
                        The receptionist is live and open to try. Talk to it the
                        way a customer would, ask about services or hours, and
                        watch it book an appointment end to end.
                    </p>
                    <a
                        className="reception-link"
                        href={RECEPTION_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Try the live demo
                    </a>
                    <p className="reception-url">reception.rileygramlich.dev</p>
                    <p className="reception-note">
                        We set it up with your business details, connect it to
                        your phone number and calendar, and stay on to tune it
                        once real calls start coming in.
                    </p>
                </article>

                <div className="reception-capabilities">
                    {capabilities.map((capability) => (
                        <article
                            key={capability.title}
                            className="reception-card"
                        >
                            <h3>{capability.title}</h3>
                            <p>{capability.detail}</p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
